/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
  OffsetDateTime,
  LocalDate,
} from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { TodoSource } from "./TodoSource";
import {
  TodoSourceFromJSON,
  TodoSourceFromJSONTyped,
  TodoSourceToJSON,
  TodoSourceToJSONTyped,
} from "./TodoSource";
import type { TodoStatus } from "./TodoStatus";
import {
  TodoStatusFromJSON,
  TodoStatusFromJSONTyped,
  TodoStatusToJSON,
  TodoStatusToJSONTyped,
} from "./TodoStatus";

/**
 *
 * @export
 * @interface Todo
 */
export interface Todo {
  /**
   *
   * @type {string}
   * @memberof Todo
   */
  todoId?: string;
  /**
   *
   * @type {string}
   * @memberof Todo
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof Todo
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof Todo
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof Todo
   */
  assignee?: string;
  /**
   *
   * @type {TodoStatus}
   * @memberof Todo
   */
  status?: TodoStatus;
  /**
   *
   * @type {TodoSource}
   * @memberof Todo
   */
  source?: TodoSource;
  /**
   *
   * @type {LocalDate}
   * @memberof Todo
   */
  date?: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof Todo
   */
  deadline?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof Todo
   */
  sourceCompanyNoteId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Todo
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Todo
   */
  createdBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Todo
   */
  updatedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Todo
   */
  updatedBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Todo
   */
  completedAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Todo
   */
  cancelledAt?: OffsetDateTime;
  /**
   *
   * @type {LocalDate}
   * @memberof Todo
   */
  snoozedUntil?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof Todo
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof Todo
   */
  sourceCarrierMeetingId?: string;
  /**
   *
   * @type {string}
   * @memberof Todo
   */
  sourceCompanyMeetingId?: string;
}

/**
 * Check if a given object implements the Todo interface.
 */
export function instanceOfTodo(value: object): value is Todo {
  return true;
}

export function TodoFromJSON(json: any): Todo {
  return TodoFromJSONTyped(json, false);
}

export function TodoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Todo {
  if (json == null) {
    return json;
  }
  return {
    todoId: json["todoId"] == null ? undefined : json["todoId"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    title: json["title"] == null ? undefined : json["title"],
    description: json["description"] == null ? undefined : json["description"],
    assignee: json["assignee"] == null ? undefined : json["assignee"],
    status:
      json["status"] == null ? undefined : TodoStatusFromJSON(json["status"]),
    source:
      json["source"] == null ? undefined : TodoSourceFromJSON(json["source"]),
    date: json["date"] == null ? undefined : json["date"],
    deadline: json["deadline"] == null ? undefined : json["deadline"],
    sourceCompanyNoteId:
      json["sourceCompanyNoteId"] == null
        ? undefined
        : json["sourceCompanyNoteId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
    updatedBy: json["updatedBy"] == null ? undefined : json["updatedBy"],
    completedAt: json["completedAt"] == null ? undefined : json["completedAt"],
    cancelledAt: json["cancelledAt"] == null ? undefined : json["cancelledAt"],
    snoozedUntil:
      json["snoozedUntil"] == null ? undefined : json["snoozedUntil"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    sourceCarrierMeetingId:
      json["sourceCarrierMeetingId"] == null
        ? undefined
        : json["sourceCarrierMeetingId"],
    sourceCompanyMeetingId:
      json["sourceCompanyMeetingId"] == null
        ? undefined
        : json["sourceCompanyMeetingId"],
  };
}

export function TodoToJSON(json: any): Todo {
  return TodoToJSONTyped(json, false);
}

export function TodoToJSONTyped(
  value?: Todo | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    todoId: value["todoId"],
    companyId: value["companyId"],
    title: value["title"],
    description: value["description"],
    assignee: value["assignee"],
    status: TodoStatusToJSON(value["status"]),
    source: TodoSourceToJSON(value["source"]),
    date: value["date"],
    deadline: value["deadline"],
    sourceCompanyNoteId: value["sourceCompanyNoteId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    updatedAt: value["updatedAt"],
    updatedBy: value["updatedBy"],
    completedAt: value["completedAt"],
    cancelledAt: value["cancelledAt"],
    snoozedUntil: value["snoozedUntil"],
    carrierIdentifier: value["carrierIdentifier"],
    sourceCarrierMeetingId: value["sourceCarrierMeetingId"],
    sourceCompanyMeetingId: value["sourceCompanyMeetingId"],
  };
}
